//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TicketItems from '@/components/TicketItems';
import { canUse } from '@/utils/order';
export default {
  props: {
    orderInfo: {
      type: Object,
      default: function _default() {// return {
        //   tickets: [{}]
        // }
      }
    }
  },
  components: {
    TicketItems: TicketItems
  },
  data: function data() {
    return {
      visible: false,
      isshowInfo: true
    };
  },
  methods: {
    canUse: canUse,
    handleClose: function handleClose() {
      this.visible = false;
    },
    open: function open() {
      this.visible = true;
      this.$emit('update');
    },
    getCodes: function getCodes(order) {
      return order.tickets ? order.tickets.filter(function (i) {
        return i.status !== 'CHANGED';
      }).map(function (t) {
        return t.selfservice_code;
      }).join('，') : '';
    }
  }
};